import React, { useEffect } from 'react'
import Error500Banner from '../../error-banners/error-500-banner'
import responseStatusStore from '../../stores/ResponseStatusStore'
const responseStatus = new responseStatusStore()

const Error500 = () => {
  useEffect(() => {
    return () => responseStatus.reset()
  }, [])

  return (
    <div
      className="flex flex-col justify-center items-center h-screen"
      style={{ backgroundColor: '#f3f4f6' }}
    >
      <Error500Banner />
      <div className="flex flex-col items-center">
        <div className="text-gray-700 text-2xl mb-4 font-bold">Internal Server Error</div>
        <a
          className="focus:outline-none focus:ring-2 focus:ring-opacity-50 focus:transition-shadow hover:ring-2 hover:ring-opacity-50 hover:transition-shadow hover:outline-none transition-shadow font-bold px-4 h-10 rounded-md flex items-center justify-center focus:ring-primary-light hover:ring-primary-light bg-primary-light text-white w-36"
          href="/"
        >
          Back to home
        </a>
      </div>
    </div>
  )
}

export default Error500
